import { createQuery } from "../../../../../util/graphql";
import PerformLoginForUser from "./PerformLoginForAdminUser.graphql";

export const loginUser = ({ endpoint, clientSlug, email, password }) =>
  createQuery(endpoint, clientSlug)(PerformLoginForUser, {
    email,
    password
  });
